import { selectApiData } from 'util/selector/apiSelector';

import { AxiosInstance } from 'axios';
import { WithData } from 'api/interfaces';
import { LangCodeEnum } from 'shared/enums/LangCodeEnum';
import { EmailTemplateTranslation } from 'api/dto/old/EmailTemplateTranslations.dto';

import {
  EmailTemplateDto,
  EmailTemplateModel,
  mapEmailTemplateDtoToModel,
  mapEmailTemplateModelToDto,
} from './dto/EmailTemplate.dto';

export class EmailTemplateApi {
  constructor(private client: AxiosInstance) {}

  create(emailDistributionId: string, model: EmailTemplateModel): Promise<EmailTemplateModel> {
    const emailTemplateDto = mapEmailTemplateModelToDto(model);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { id: emailTemplateId, ...data } = emailTemplateDto;

    return this.client
      .post(`/api/v1/distribution/${emailDistributionId}/email-template`, data)
      .then(selectApiData)
      .then(mapEmailTemplateDtoToModel);
  }

  update(model: EmailTemplateModel): Promise<EmailTemplateModel> {
    const emailTemplateDto = mapEmailTemplateModelToDto(model);
    const { id: emailTemplateId, ...data } = emailTemplateDto;

    return this.client
      .post(`/api/v1/email-template/${emailTemplateId}`, data)
      .then(selectApiData)
      .then(mapEmailTemplateDtoToModel);
  }

  delete(emailTemplateId: number): Promise<any> {
    return this.client.delete(`/api/v1/email-template/${emailTemplateId}`);
  }

  saveEmailTemplateTranslations({
    emailTemplateId,
    translations,
  }: {
    emailTemplateId: number;
    translations: EmailTemplateTranslation[];
  }): Promise<EmailTemplateDto> {
    return this.client
      .post<WithData<EmailTemplateDto>>(`/api/v1/email-template/${emailTemplateId}/translations`, {
        translations,
      })
      .then(selectApiData);
  }

  getTranslatedEmailTemplate({
    emailTemplateId,
    language,
  }: {
    emailTemplateId: number;
    language: LangCodeEnum;
  }) {
    return this.client
      .get<
        WithData<EmailTemplateDto>
      >(`/api/v1/email-template/${emailTemplateId}?locale=${language}`)
      .then(selectApiData)
      .then(mapEmailTemplateDtoToModel);
  }
}
